import 'isomorphic-fetch';

interface BasicResult {
    result: string;
}

interface BasicPostData {
    firstData: string;
    secondData: number;
}

class AboutViewModel {
    public message = ko.observable("");
    constructor(params: any) {
        //toastr["error"]("Mail services are currently down. Please Contact us another way, thank you.");
        
        let vid: HTMLVideoElement = document.getElementById("myVideo") as HTMLVideoElement;
        vid.playbackRate = 0.5;
        // t.error('wtf', '', { closeButton: true });
        //var fetchstring =  globals.apiUrl + "api/Data/BasicGet";
        //if (params.id) {
        //    console.warn(params.id);
        //    fetchstring = fetchstring + "/" + params.id;
        //}
        //fetch(fetchstring)
        //    .then(response => response.json() as Promise<BasicResult>)
        //    .then(data => {
        //        this.message(data.result);
        //    });

        //let basicpostData = {firstData: "Ben", secondData: 1};
        //fetch(globals.apiUrl + "api/Data/BasicPost", {
        //    method: "POST",
        //    body: JSON.stringify(basicpostData),
        //    headers: {
        //        "Content-Type": "application/json"
        //    },
        //    credentials: "same-origin"
        //}).then(function (response) {
        //    response.status     //=> number 100–599
        //    response.statusText //=> String
        //    response.headers    //=> Headers
        //    response.url        //=> String

        //    return response.text()
        //}, function (error) {
        //    error.message //=> String
        //})
    }

}

export default { viewModel: AboutViewModel, template: require('./about.html') };